<script lang="ts">
	import type { SvelteComponent } from 'svelte';
	import { PUBLIC_ENV_MODE } from '$env/static/public';
	import FailedBlockSection from './debugging/FailedBlockSection.svelte';

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	type SvelteComponentConstructor = new (...args: any) => SvelteComponent;

	let {
		sections,
		caller,
		sectionMap,
		showErrors = true,
		...rest
	}: {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		sections: any;
		caller: string;
		sectionMap: Map<string, SvelteComponentConstructor>;
		showErrors?: boolean;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} & any = $props();

	// Ensure rerendering when sections change
	const sectionsWithIds = $derived(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		sections.map((s: any, i: any) => ({ ...s, id: `${caller}-${i}` }))
	);
</script>

{#each sectionsWithIds as section, index (section.id)}
	{@const block = sectionMap.get(section._modelApiKey)}
	{#if block}
		<svelte:component this={block} data={section} {index} {...rest} />
	{:else if PUBLIC_ENV_MODE === 'development' && showErrors}
		{#if section._modelApiKey === 'failed'}
			<FailedBlockSection data={section} />
		{:else}
			<FailedBlockSection
				data={{
					_modelApiKey: 'failed',
					targetModelApiKey: section._modelApiKey,
					fromCMS: null,
					failedMessage:
						'BlockRenderer missing this block, you need to add it to the BlockRenderer in ' + caller
				}}
			/>
		{/if}
	{/if}
{/each}
